<div class="author-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ ('BUTTON.' + data.mode | translate) + ' ' + (data.type + '.TITLE' | translate) }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		@if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="formGroup" (keydown.enter)="action()">
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME_CYRILLIC' | translate }}</mat-label>
					<input matInput type="text" formControlName="nameCyrillic" cdkFocusInitial />
					<mat-icon
						class="cursor-pointer"
						matTooltip="{{ 'ASSORTED.TRANSLITERATE' | translate }}"
						matTooltipPosition="below"
						matSuffix
						(click)="transliterate('nameCyrillic', 'nameLatin', 'CYR_LAT')"
						>move_down</mat-icon
					>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME_LATIN' | translate }}</mat-label>
					<input matInput type="text" formControlName="nameLatin" />
					<mat-icon
						class="cursor-pointer"
						matTooltip="{{ 'ASSORTED.TRANSLITERATE' | translate }}"
						matTooltipPosition="below"
						matSuffix
						(click)="transliterate('nameLatin', 'nameCyrillic', 'LAT_CYR')"
						>move_up</mat-icon
					>
				</mat-form-field>
			</div>
		</form>
		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByLanguageScript(data.item, 'name') }}? </span>
		} @else if (data.mode === 'DELETE_REASSIGN') {
		<div class="pb-2">
			<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByLanguageScript(data.item, 'name') }}? </span>
			<br />
			<span> {{ utils.getParameterByLanguageScript(data.item, 'name') }} {{ data.type + '.DELETE_RELATED_WITH_CLIPS' | translate }} ( {{ itemRelatedClips }} ) </span>
		</div>

		<form [formGroup]="formGroup" class="row">
			<mat-form-field appearance="outline">
				<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
				<input type="text" matInput formControlName="reassignTo" [matAutocomplete]="authorAutocomplete" [readonly]="formGroup.controls['reassign'].value" />
				<mat-autocomplete #authorAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
					@for (filteredItem of filteredAuthors; track $index) {
					<mat-option [value]="filteredItem">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>

			<div class="row pb-0">
				<mat-checkbox class="mt-2" color="primary" formControlName="reassign">
					<span>{{ data.type + '.REASSIGN_CONFIRMATION' | translate }}</span>
				</mat-checkbox>
			</div>
		</form>
		}
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (data.mode === 'DELETE' || data.mode === 'DELETE_REASSIGN') {
		<div class="d-flex justify-content-end pt-0">
			<button
				mat-flat-button
				color="warn"
				(click)="action()"
				[disabled]="data.mode !== 'DELETE' && !(formGroup.controls['reassignTo'].value || formGroup.controls['reassign'].value)">
				{{ 'ASSORTED.YES' | translate }}
			</button>
			<button mat-flat-button color="primary" (click)="closeDialog()">
				{{ 'ASSORTED.NO' | translate }}
			</button>
		</div>
		} @else {
		<div class="d-flex pt-0">
      <button mat-flat-button color="primary" (click)="action()" [disabled]="formGroup.invalid || apiLoading.management">
				<div class="d-flex">
					@if(apiLoading.management) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'BUTTON.SAVE' | translate }}</span>
				</div>
			</button>
		</div>
		}
	</mat-dialog-actions>
</div>
